import React, { useState, useEffect } from 'react';

const KEY = 'doar_cookie_notice_seen';

function noticeBottomOffset() {
  const host = String(window.location.hostname || "").toLowerCase();
  const surface = String(process.env.REACT_APP_PUBLIC_SURFACE || "").toLowerCase();
  const theDoar = host === "thedoar.com" || host === "www.thedoar.com" || host === "localhost-marketplace" || surface === "marketplace";
  const publicRealityPath = window.location.pathname === "/"
    || window.location.pathname === "/marketplace"
    || /^\/(?:r|m)\//.test(window.location.pathname);
  return theDoar && publicRealityPath
    ? "max(76px, calc(env(safe-area-inset-bottom) + 68px))"
    : 20;
}

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  function dismiss() {
    localStorage.setItem(KEY, '1');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="doar-cookie-notice" role="region" aria-label="Cookie information" style={{
      position: 'fixed', bottom: noticeBottomOffset(), left: '50%', transform: 'translateX(-50%)',
      zIndex: 9998,
      background: '#111317',
      border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: 12,
      padding: '12px 18px',
      display: 'flex', alignItems: 'center', gap: 14,
      boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      maxWidth: 'min(560px, 92vw)',
      width: '100%',
    }}>
      <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', lineHeight: 1.5, flex: 1 }}>
        We use cookies to keep you signed in and improve your experience.{' '}
        <a href="/privacy" style={{ color: 'rgba(167,139,250,0.8)', textDecoration: 'none' }}>Privacy policy</a>
      </span>
      <button
        onClick={dismiss}
        style={{
          flexShrink: 0,
          background: 'rgba(167,139,250,0.15)',
          border: '1px solid rgba(167,139,250,0.25)',
          borderRadius: 8,
          color: 'rgba(167,139,250,0.9)',
          fontSize: 12, fontWeight: 600,
          padding: '6px 14px',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Got it
      </button>
    </div>
  );
}
